var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn m-2",class:_vm.favorite ? 'btn-orange' : 'btn-grey',style:(_vm.getPositionStyle()),attrs:{"type":"button","title":_vm.favorite ? _vm.$t('article.in_your_library') : _vm.$t('article.add_to_library')}},[_c('i',{staticClass:"far fa-bookmark"})])
}
var staticRenderFns = []

export { render, staticRenderFns }